// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"93693fc0","508":"7dc6a021","811":"fc950044","825":"26399e22"}[chunkId] + ".chunk.css";
};